import { collection, CollectionReference, doc, setDoc, updateDoc } from "firebase/firestore";
import React, { useEffect } from "react";
import { useFirestore, useFirestoreCollectionData, useFirestoreDocData } from "reactfire";
import { appStore } from "../utils/AppMobx";

export const SettingsPage = () => {
	const firestore = useFirestore();
	const settingsRef = doc(firestore, "/store/site/settings/siteSettings");
	const settingsData = useFirestoreDocData(settingsRef);
	const [titlePrompt, setTitlePrompt] = React.useState("");
	const [descriptionPrompt, setDescriptionPrompt] = React.useState("");
	useEffect(() => {
		if (settingsData.status === "success") {
			setTitlePrompt(settingsData?.data?.titlePrompt || "");
			setDescriptionPrompt(settingsData?.data?.descriptionPrompt || "");
		}
	}, [settingsData]);
	if (settingsData.status === "loading") {
		return <div>Loading...</div>;
	}

	return (
		<div className="flex flex-col h-screen p-4">
			<h1 className="text-xl">Settings</h1>
			<p>Title Prompt:</p>
			<textarea
				value={titlePrompt || ""}
				onChange={(e) => {
					setTitlePrompt(e.target.value);
				}}
				placeholder="Enter title prompt"
				rows={5}
				className="border p-2 w-[600px] rounded mb-4 settings-textarea"
			/>
			<p>Description Prompt</p>
			<textarea
				value={descriptionPrompt || ""}
				onChange={(e) => {
					setDescriptionPrompt(e.target.value);
				}}
				placeholder="Enter description prompt"
				rows={5}
				className="border p-2 w-[600px] rounded mb-4 settings-textarea"
			/>
			<button
				onClick={async () => {
					appStore.showLoading = true;
					await setDoc(
						settingsRef,
						{
							titlePrompt: titlePrompt,
							descriptionPrompt: descriptionPrompt,
						},
						{ merge: true }
					);
					appStore.showLoading = false;
					alert("Settings updated successfully!");
				}}
				className="w-32 h-10 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
			>
				Update Settings
			</button>
		</div>
	);
};
